<template>
  <div class="appText">
    <div class="content" v-html="text"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "<i>ABL1<i>基因是一种原癌基因，其编码的蛋白酪氨酸激酶参与细胞分裂、粘附、分化和应激反应等多种细胞过程。由t（9;22）（q34;q11）易位形成<i>BCR<i>-<i>ABL1<i>融合基因为慢性髓性白血病中最常见的<i>ABL1<i>融合形式，该融合基因引起酪氨酸激酶的持续激活，导致细胞增殖失调。",
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("进入页面");
    window.NativeCallJS = (res) => {
      let par = JSON.parse(res);
      console.log(par, "移动端给的值");
      next((vm) => {
        vm.text = par.text;
      });
    };
  },
};
</script>

<style lang="less" scoped>
.appText {
  .content {
    word-break: break-all;
    text-align: justify;
    text-justify: inter-ideograph;
    text-justify: auto;
    font-size: 15PX;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5f697d;
    line-height: 28px;
    /deep/i {
      font-style: normal;
    }
  }
}
</style>